import { EventHandlerConfig } from "@/widgetLibrary/interface"

export const PDF_EVENT_HANDLER_CONFIG: EventHandlerConfig = {
  events: [],
  methods: ["setFileUrl"],
}
